import React from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import Field from 'core/components/form/form.v2';

export const structureInitialValues = {
  description: '',
  structureDetail: ''
};

export const structureValidationSchema = Yup.object().shape({
  description: Yup.string().required('Item name is required')
});

const NotOnPolicyStructure = ({ disabled }) => {
  return (
    <>
      <Field
        xs={12}
        type="string"
        name="description"
        mode="dark"
        label="Item name*"
        helperText="Give this item a small name for reference"
        disabled={disabled}
      />
      <Field
        xs={12}
        type="textarea"
        name="structureDetail"
        mode="dark"
        label="Description of structure"
        disabled={disabled}
      />
    </>
  );
};

NotOnPolicyStructure.propTypes = {
  disabled: PropTypes.bool.isRequired
};

export default NotOnPolicyStructure;
